var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "token-card" },
    [
      _c("div", { staticClass: "col title click-able" }, [
        _c("div", { staticClass: "token-meta" }, [
          _c("img", {
            staticClass: "icon",
            attrs: { src: _vm.token.icon },
            on: {
              click: function() {
                return _vm.showDetail()
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "name-wrapper",
              on: {
                click: function() {
                  return _vm.showDetail()
                }
              }
            },
            [
              _c("div", { staticClass: "token-symbol" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.getTokenSymbolString(
                        _vm.token.tokenSymbol,
                        _vm.token.index
                      )
                    ) +
                    "\n                "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "token-name" }, [
                _vm._v(_vm._s(_vm.token.tokenName))
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "separate" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col click-able" }, [
        _c("div", [
          _vm._v(
            "\n            " +
              _vm._s((_vm.token.balance || 0) + " " + _vm.token.tokenSymbol) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "op_group" }, [
          _c("div", { staticClass: "op", on: { click: _vm._send } }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("tokenCard.actionType.SEND")) +
                "\n            "
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _vm._v(
          "\n        " +
            _vm._s((_vm.token.fundFloat || 0) + " " + _vm.token.tokenSymbol) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c(
          "div",
          {
            class: {
              underline: _vm.gateName !== "--",
              "click-able": _vm.gateName !== "--"
            },
            on: {
              click: function() {
                return _vm.gateName !== "--" && _vm.showDetail("gate")
              }
            }
          },
          [_vm._v("\n            " + _vm._s(_vm.gateName) + "\n        ")]
        ),
        _vm._v(" "),
        _vm.token.gateInfo.url
          ? _c("div", { staticClass: "op_group" }, [
              _c("div", { staticClass: "op", on: { click: _vm.charge } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("tokenCard.actionType.CHARGE")) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "op", on: { click: _vm._withdraw } }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("tokenCard.actionType.WITHDRAW")) +
                    "\n            "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "op readonly",
                  on: {
                    click: function() {
                      return _vm.showDetail("withdraw")
                    }
                  }
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("tokenCard.actionType.RECRODS")) +
                      "\n            "
                  )
                ]
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "separate" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _vm._v(
          "\n        " +
            _vm._s((_vm.exBanlance || 0) + " " + _vm.token.tokenSymbol) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c("div", [
          _vm._v(
            "\n            " +
              _vm._s(
                (_vm.avaliableExBalance || 0) + " " + _vm.token.tokenSymbol
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "op_group" }, [
          _c("div", { staticClass: "op", on: { click: _vm._exTransfer } }, [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("tokenCard.actionType.EXTRANSFER")) +
                "\n            "
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "op readonly", on: { click: _vm.exRecord } },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("tokenCard.actionType.EXRECRODS")) +
                  "\n            "
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "separate" })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col" }, [
        _c("div", { staticClass: "assets" }, [
          _c("div", { staticClass: "est_btc" }, [
            _vm._v(_vm._s(_vm.assetView.btc) + " BTC")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "est_cash" }, [
            _vm._v(
              "\n                ≈" +
                _vm._s(_vm.currencySymbol) +
                " " +
                _vm._s(_vm.assetView.cash) +
                "\n            "
            )
          ])
        ]),
        _vm._v(" "),
        _vm.showUnbind
          ? _c("div", {
              staticClass: "unbind click-able",
              on: { click: _vm.unbind }
            })
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("Alert", { ref: "alert", attrs: { token: _vm.token } }),
      _vm._v(" "),
      _vm.isShowTrans
        ? _c("transaction", {
            attrs: { closeTrans: _vm.closeTrans, token: _vm.token }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("exTransfer", { ref: "exTransfer", attrs: { tokenInfo: _vm.token } }),
      _vm._v(" "),
      _c("important-hint", {
        ref: "importantHintDom",
        attrs: { tokenInfo: _vm.token }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }